import { render } from "./LogTargetList.vue?vue&type=template&id=71b07462"
import script from "./LogTargetList.vue?vue&type=script&lang=js"
export * from "./LogTargetList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__